module.exports = __webpack_public_path__ + "img/background-account.f5b96144.png";